<template>
  <v-app id="page-top" style="background: #fafafa">
    <a href="#main-content" class="skip-link">Skip to main content</a>
    <AppNav v-if="$store.state.auth.isAuthenticated"></AppNav>
    <AppSidebar></AppSidebar>

    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        fixed
        small
        bottom
        dark
        right
        color="#088078"
        transition="scale-transition"
        @click="toTop"
        aria-label="Click to scroll to top"
        v-if="!$route.meta.hideScrollButton"
      >
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-main>
      <span
        v-if="!$myApp.config.underConstruction"
        style="min-height: 120vh !important"
      >
        <ApolloQuery
          :query="GET_ALERT"
          notifyOnNetworkStatusChange
          v-if="!$route.meta.hideAlert"
        >
          <template slot-scope="{ result }">
            <div v-if="result.error" class="text-center error apollo">
              <div>{{ result.error }}</div>
              <div>Please <a href="/login/">login again</a></div>
            </div>

            <div v-if="!isLoading(result.loading) && !result.error">
              <Alert
                :type="result.data.home.alert.alertType"
                :text="result.data.home.alert.text"
                :dismissable="result.data.home.alert.dismissable"
                v-if="result.data.home.alert"
              ></Alert>
            </div>
          </template>
        </ApolloQuery>
        <div id="main-content" tabindex="-1" aria-live="polite">
          <transition name="fade" mode="out-in">
            <router-view
              class="pb-12"
              style="min-height: 100vh !important"
            ></router-view>
          </transition>
        </div>
      </span>
      <span v-else>
        <ComingSoon></ComingSoon>
      </span>
    </v-main>
    <AppFooter v-if="$store.state.auth.isAuthenticated"></AppFooter>
  </v-app>
</template>

<script>
import { GET_ALERT } from "@/graphql/queries/alert.js";
import { startA11yObserver } from "@/a11y";
// import NProgress from "nprogress";
export default {
  /* eslint-disable no-unused-vars */
  name: "App",
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // Move focus to main content after route change for screen readers.
      // preventScroll keeps the a11y focus from scrolling #main-content up under
      // the fixed app bar (which left headings clipped and the page ~64px below
      // the top on navigation); the router's scrollBehavior handles scroll-to-top.
      this.$nextTick(() => {
        const main = document.getElementById("main-content");
        if (main) main.focus({ preventScroll: true });
      });
    },
  },
  mounted() {
    // Start MutationObserver to continuously patch Vuetify 2 a11y issues
    startA11yObserver();
    // The Facebook SDK is loaded lazily by the Facebook component
    // (src/components/Facebook.vue) only on the /social/facebook/ route,
    // rather than app-wide on every page.
  },

  components: {},

  data: () => ({
    fab: false,
    GET_ALERT,
  }),
  methods: {
    isLoading(loading) {
      // eslint-disable-next-line no-undef
      loading ? window.NProgress.start() : window.NProgress.done();
      return loading ? true : false;
    },

    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 100;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.container.full-width {
  width: 100%;
  padding: 0px !important;
}
body:not(.page-form) .grecaptcha-badge {
  display: none;
}
.skip-link {
  position: absolute;
  top: -100px;
  left: 0;
  background: #113959;
  color: #fff !important;
  padding: 8px 16px;
  z-index: 9999;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
}
.skip-link:focus {
  top: 0;
}
#main-content:focus {
  outline: none;
}
</style>
